import { create } from 'zustand';
import { feedbackType } from '@mygpt/app/chat/services';
import { ratingType } from '@mygpt/types';

interface FeedbackModalState {
  // Modal 开关状态
  opened: boolean;

  // Modal 类型（好评/差评）
  modalType: feedbackType;

  // 用户点击反馈按钮的当前消息的信息，用语最后提交接口的参数
  currentMessageInfo: {
    aiId: string;
    sessionId: string;
    messageId: string;
    rating?: ratingType;
  };

  openModal: (type: feedbackType) => void;
  closeModal: () => void;

  setCurrentMessageInfo: (currentMessageInfo: {
    aiId: string;
    sessionId: string;
    messageId: string;
    rating?: ratingType;
  }) => void;
}

export const useFeedbackModal = create<FeedbackModalState>((set) => ({
  opened: false,
  modalType: 'good',
  currentMessageInfo: {
    aiId: '',
    sessionId: '',
    messageId: '',
    rating: undefined,
  },

  openModal: (type) => {
    set({
      opened: true,
      modalType: type,
    });
  },

  closeModal: () => {
    set({
      opened: false,
    });
  },

  setCurrentMessageInfo: (currentMessageInfo: {
    aiId: string;
    sessionId: string;
    messageId: string;
    rating?: ratingType;
  }) => {
    set({ currentMessageInfo });
  },
}));
